import React, { Component } from 'react';
import { Button, Icon } from 'semantic-ui-react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { Dropzone } from 'Components';
import ReactDropzone from 'react-dropzone';
import { Formatters } from 'Common/Helpers';
import { ImagePreview } from 'Common/ImagePreview';
import { createToast, toastType } from 'Common/ToastHelper';

import {
  DISPLAY_IMAGE,
  DISPLAY_PREVIEW,
  DISPLAY_STOCK_PREVIEW,
  ACCEPTED_IMAGE_TYPES,
} from 'Common/Constants/';

class ImageUploader extends Component {
  static propTypes = {
    onImageRemove: PropTypes.func.isRequired,
    onDrop: PropTypes.func.isRequired,
    alt: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
  };

  state = {
    status: '',
    image: '',
    disabled: false,
  };

  dropzoneRef = React.createRef();

  onDrop = (files) => {
    if (this.props.onDrop) {
      this.props.onDrop(files);
    }

    if (files[0] !== undefined && files[0] !== 0) {
      this.setState({
        image: files[0],
        status: DISPLAY_PREVIEW,
      });
    }
  };

  clearSelection = () => {
    this.props.onImageRemove();
    this.setState({ status: '', image: '' });
  };

  handleChangeImage = () => {
    this.dropzoneRef.current.open();
  };

  componentDidMount = () => {
    const { displayImage } = this.props;
    if (displayImage) {
      this.setState({ status: DISPLAY_IMAGE, image: displayImage });
    }
  };

  componentDidUpdate = (prevProp) => {
    const { displayImage } = this.props;
    if (displayImage && prevProp.displayImage !== displayImage) {
      this.setState({ status: DISPLAY_IMAGE, image: displayImage });
    }
  };

  renderComponent = () => {
    const { status, image } = this.state;
    const { alt, disabled } = this.props;

    switch (status) {
      case DISPLAY_PREVIEW:
        return (
          <figure>
            <ImagePreview
              className={`image-uploader-form--image-preview-wrapper`}
              file={image}
              alt={alt}
            />
            <figcaption>
              <Button
                className={`image-uploader-form--remove-image-preview`}
                onClick={this.clearSelection}
              >
                Remove Preview
              </Button>
            </figcaption>
          </figure>
        );

      case DISPLAY_IMAGE:
        return (
          <figure>
            <ReactDropzone
              ref={this.dropzoneRef}
              accept={ACCEPTED_IMAGE_TYPES.join(',')}
              activeClassName="file--dropzone--active"
              rejectClassName="file--dropzone--error"
              multiple={false}
              style={{}} // to remove inline style created by ReactDropzone
              onDrop={this.onDrop}
              onDropRejected={() => {
                createToast(
                  toastType.error,
                  'Error',
                  `Supported image types: ${ACCEPTED_IMAGE_TYPES.join(', ')}`
                );
              }}
              disabled={disabled}
            >
              <img src={Formatters.prependBase64(image)} alt={alt} />
            </ReactDropzone>
            {!disabled && (
              <figcaption>
                <Button onClick={this.handleChangeImage}>Change</Button>
                <Button onClick={this.clearSelection}>Remove</Button>
              </figcaption>
            )}
          </figure>
        );

      case DISPLAY_STOCK_PREVIEW:
        return (
          <figure>
            <span className={`image-uploader-form--image-stock`}>
              <Icon name="file" size="massive" />
            </span>
          </figure>
        );

      default:
        const className = classNames(
          'file--dropzone image-uploader-form--dropzone',
          'file--dropzone-limited-width'
        );
        return (
          <Dropzone
            accept={ACCEPTED_IMAGE_TYPES.join(',')}
            activeClassName="file--dropzone--active"
            rejectClassName="file--dropzone--error"
            className={className}
            multiple={false}
            onDrop={this.onDrop}
            onDropRejected={() => {
              createToast(
                toastType.error,
                'Error',
                `Supported image types: ${ACCEPTED_IMAGE_TYPES.join(', ')}`
              );
            }}
            disabled={disabled}
          >
            <p>
              Drag and drop your file here <br />
              <small>or click to select image</small>.
            </p>
          </Dropzone>
        );
    }
  };

  render() {
    return (
      <div className="image-uploader-form--image-uploader-image-wrapper">
        {this.renderComponent()}
      </div>
    );
  }
}

export default ImageUploader;

export { ImageUploader };



// WEBPACK FOOTER //
// ./src/common/Components/ImageUploader/ImageUploader.js